import { Popup, PopupButton, PopupContent, PopupPosition } from "./utilities/popup.js";
import { getTranslations, menuAccountItems } from "./translations.js";
import { MenuItem } from "./models/MenuItemModel.js";
import { sendApiCall } from "./utilities/api";
import { CountryPopup } from "./components/countryPopup.js";
import "/js/smulders/components/shoppingcart/cartpopup.ts";
import { initAutoComplete } from "/js/smulders/general.end";
import { sendDataLayer } from "./components/ecommerce/ecommerce";
import { sendWebVitals } from "./components/ecommerce/gawrapper";

const mobileMediaQuery = window.matchMedia("(max-width: 768px)");

declare const UIkit: any;
declare const Cookies: any;

let oldSearchBarText = "";

class Pro6PPAddressDto
{
    public zipCode: string | null = null;
    public houseNumber: string | number | null = null;
    public countryCode: string | null = null;
    public countryID: number | null = null;
    public street: string | null = null;

    constructor(data?: {
        zipCode?: string;
        houseNumber?: string | number;
        countryCode?: string;
        countryID?: number;
        street?: string;
    })
    {
        if (data)
        {
            this.zipCode = data.zipCode ?? null;
            this.houseNumber = data.houseNumber ?? null;
            this.countryCode = data.countryCode ?? null;
            this.countryID = data.countryID ?? null;
            this.street = data.street ?? null;
        }
    }
}

window.addEventListener("DOMContentLoaded", (event: Event) =>
{
    checkSiteNotification(null, event);

    setAllValidateAddressEvents();

    if (document.querySelector(".js-header-account"))
    {
        if (shopConfig().userLoggedIn)
            document.querySelector(".js-header-account").classList.add("c-header-icon-counter--loggedin");
        else
            document.querySelector(".js-header-account").classList.add("c-header-icon-counter--login");
    }

    handleStash();
    sendWebVitals();
    setupOldBrowserWarning();
});

window.addEventListener("load", (event: Event) =>
{
    initMobileMenu();
    loadSearchBarEvents();
});

//#region Notification

const notificationKey = "siteNotificationClosed";

function closeSiteNotification(e: JQuery, event?: Event): void
{
    if (event)
        event.preventDefault();

    sessionStorage[notificationKey] = "1";
    document.querySelector(".w-notification").classList.add("hidden");
}

function checkSiteNotification(e: JQuery, event?: Event): void
{
    if (event)
        event.preventDefault();

    if (sessionStorage[notificationKey] === "1")
        closeSiteNotification(e, event);
}

(window as any).closeSiteNotification = closeSiteNotification;

//#endregion Notification

//#region Header

//#region Header usp slider

const headerUspSliderHolder = document.querySelector<HTMLElement>(".c-header-usp__holder");
const headerUspSlider = document.querySelector<HTMLElement>(".c-header-usp");

if (headerUspSliderHolder &&
    headerUspSlider)
{
    let headerUspSliderInstance: any = null;

    const handleBreakpointChange = (e: MediaQueryListEvent | MediaQueryList) =>
    {
        // Add slider for mobile.
        if (e.matches)
        {
            headerUspSliderHolder.classList.add("uk-slider-container");
            headerUspSlider.classList.add("uk-slider-items", "uk-child-width-1-1");

            UIkit.update(headerUspSliderHolder);

            if (!headerUspSliderInstance)
            {
                headerUspSliderInstance = UIkit.slider(
                    headerUspSliderHolder,
                    {
                        autoplay: true,
                        autoplayInterval: 5000,
                        finite: false,
                        draggable: true,
                        active: "all"
                    }
                );
            }
        }
        // Remove slider for desktop.
        else
        {
            if (headerUspSliderInstance)
            {
                headerUspSliderInstance.$destroy(false);
                headerUspSliderInstance = null;
            }

            headerUspSliderHolder.classList.remove("uk-slider-container", "uk-slider");
            headerUspSlider.classList.remove("uk-slider-items", "uk-child-width-1-1");

            headerUspSlider.removeAttribute("style");
            Array.from(headerUspSlider.children).forEach(child =>
            {
                child.removeAttribute("style");
                child.classList.remove("uk-active");
            });

            if (headerUspSliderInstance)
            {
                headerUspSliderInstance.$destroy(false);
                headerUspSliderInstance = null;
            }

            UIkit.update(headerUspSliderHolder);
        }
    };

    mobileMediaQuery.addEventListener("change", handleBreakpointChange);

    // Run once after page load.
    handleBreakpointChange(mobileMediaQuery);
}

const headerUsp = document.querySelector<HTMLElement>(".c-header-usp");
const headerUspTarget = document.querySelector<HTMLElement>(".js-headerusp-target");

// Copy to body target.
if (headerUsp &&
    headerUspTarget)
{
    const headerUspListItems = headerUsp.querySelectorAll<HTMLLIElement>("li");

    const uspListWrapper = document.createElement("div");
    uspListWrapper.classList.add("c-slider");
    uspListWrapper.setAttribute("data-slider-autoplay", "true");

    const uspListOutlineOffset = document.createElement("div");
    uspListOutlineOffset.classList.add("c-slider__outline-offset");

    const uspList = document.createElement("ul");
    uspList.classList.add("c-page-usp", "list-check", "c-slider__content-holder", "c-header-usp", "m-none");

    headerUspListItems.forEach((li) =>
    {
        const clonedLi = li.cloneNode(true) as HTMLLIElement;

        clonedLi.querySelector("a")?.removeAttribute("class");
        clonedLi.querySelector("a")?.classList?.add("f-primary-s");

        clonedLi.querySelector("span")?.removeAttribute("class");
        clonedLi.querySelector("span")?.classList?.add("f-primary-s");

        uspList.appendChild(clonedLi);
    });

    uspListOutlineOffset.appendChild(uspList);
    uspListWrapper.appendChild(uspListOutlineOffset);
    headerUspTarget.appendChild(uspListWrapper);
}

//#endregion Header usp slider

//#region Search submit

function searchSubmit(searchForm: HTMLElement | JQuery, event?: JQuery.Event | Event): void
{
    const $form = $(searchForm);

    const searchValue = (($form.find(".c-searchbar__input").val() as string) || "");

    // Copy to all search forms if there are multiple.
    $(".c-searchbar__input").val(searchValue);

    // Start search.
    searchArticles();

    if (event)
        event.preventDefault();
}

(window as any).searchSubmit = searchSubmit;

function searchArticles(): void
{
    const searchInputValue = (($(".c-searchbar__input").val() as string) || "").trim();

    // Submit form only if we have input and nothing in the suggestionbox is selected.
    if (searchInputValue.length > 1 &&
        $(".c-searchbar__selected-line").length <= 0)
    {
        searchCookie(true);

        // Create the form element via JQuery.
        const $form = $("<form></form>");
        $form.attr("method", "POST");
        $form.attr("action", getTranslations().searchUrl);
        $form.attr("name", "search-form");

        // Clone the input, hide it, and append it.
        const $clonedInput = $(".c-searchbar__form .c-searchbar__input").clone().css("display", "none");
        $form.append($clonedInput);

        $("body").append($form);
        $form.trigger("submit");
    }
}

function searchCookie(createCookie: boolean): void
{
    if (createCookie)
    {
        const expirationDate = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 1);

        const searchValue = ($(".c-searchbar__input").val() as string) || "";
        Cookies.set("search_keyword", searchValue, { path: "/", expires: expirationDate });
    }
    else
    {
        const savedKeyword = Cookies.get("search_keyword");

        // Check if the cookie actually has a valid string value.
        if (savedKeyword && savedKeyword !== "undefined")
        {
            const currentUrl = window.location.href;

            if (currentUrl.includes("shopmode/search") ||
                currentUrl.includes(getTranslations().searchUrl) ||
                // TODO: Change class.
                $(".product-detail").length > 0
            )
                $(".c-searchbar__input").val(savedKeyword);
            else
            {
                // Destroy the cookie if we're not searching or showing a product.
                Cookies.remove("search_keyword");

                $.ajax({
                    url: "/Services/Modules/Webshop.asmx/RemoveSearchKeyword",
                    type: "POST",
                    contentType: "application/json; charset=utf-8"
                });
            }
        }
    }
}

//#endregion Search submit

//#region Search events

function loadSearchBarEvents(): void
{
    const searchBarClickEventHandler = function (this: HTMLInputElement, e: JQuery.TriggeredEvent): void
    {
        if (window.matchMedia("(max-width: 768px)").matches)
        {
            var template = $('.c-searchbar').html();

            const searchBarPopup = new Popup({
                id: "mobile-searchbar",
                content: template,
                closeButton: false,
                desktopPosition: PopupPosition.Center,
                mobilePosition: PopupPosition.fullScreen,
            });

            searchBarPopup.show();
            initAutoComplete();
            $('#modal-mobile-searchbar .c-searchbar__input').attr("name", "searchbar-mobile");
            $('#modal-mobile-searchbar .c-searchbar__input').trigger("focus");
            $('#modal-mobile-searchbar .c-searchbar__input').trigger("blur");
            $('#modal-mobile-searchbar .c-searchbar__input').trigger("focus");

            $('.c-searchbar__form-cancel').on("click", (e) =>
            {
                searchBarPopup.hide();
            });
        }

        // Only when input field is empty.
        if ($(this).val() === "")
        {
            const $suggestionBlock = $(".c-searchbar__suggestion");

            if ($suggestionBlock.length > 0)
            {
                $suggestionBlock.html("");

                const $suggestions = $(".c-searchbar__suggestion-list");

                if ($suggestions.length > 0)
                {
                    $suggestionBlock.append($suggestions.clone());

                    let searchCurrentIndex = -1;
                    oldSearchBarText = "";

                    $(".c-searchbar__form .c-searchbar__input").on("keydown", function (this: HTMLInputElement, ke: JQuery.KeyDownEvent)
                    {
                        const $searchListItems = $(".c-searchbar .c-searchbar__suggestion-item");

                        if ($searchListItems.length > 0)
                        {
                            const $searchVisibleItems = $searchListItems.filter(":visible");
                            const searchVisibleCount = $searchVisibleItems.length;

                            // TODO: If search becomes empty, show suggestions again.
                            // NOTE: Backspace and Delete keys can both remove text, or even using right click and cut.
                            // Using cases for Backspace/Delete is not 100% fool-proof.

                            // TODO: Fix bug where if arrows are used to select a 'c-searchbar__selected-line',
                            // typing in the search bar subsequently bugs out.
                            // Already existed before redesign, but was found during.

                            switch (ke.key)
                            {
                                case "Enter": // 13
                                    if (searchVisibleCount > 0 && searchCurrentIndex >= 0)
                                    {
                                        $searchVisibleItems.eq(searchCurrentIndex).find("a")[0].click();
                                    }

                                    break;
                                case "Escape": // 27
                                    //HideFadeOverlay("#searchsuggestionoverlay");

                                    break;
                                case "ArrowUp": // 38
                                    if (searchCurrentIndex >= 0)
                                        searchCurrentIndex--;

                                    if (searchCurrentIndex >= 0 && !$searchVisibleItems.eq(searchCurrentIndex).find("a").length)
                                        searchCurrentIndex--;

                                    if (searchCurrentIndex < 0)
                                        $(this).val("");

                                    break;
                                case "ArrowDown": // 40
                                    if (searchCurrentIndex < searchVisibleCount - 1)
                                        searchCurrentIndex++;

                                    if (searchCurrentIndex >= 0 && !$searchVisibleItems.eq(searchCurrentIndex).find("a").length)
                                        searchCurrentIndex++;

                                    break;
                            }

                            $searchListItems.removeClass("c-searchbar__selected-line");

                            if (searchCurrentIndex !== -1)
                                $searchVisibleItems.eq(searchCurrentIndex).addClass("c-searchbar__selected-line");

                            if (searchVisibleCount > 0 && searchCurrentIndex >= 0)
                            {
                                const $selectedItem = $(".c-searchbar__selected-line");

                                if ($selectedItem.length > 0)
                                {
                                    let newText = "";
                                    const productText = $selectedItem.first().find(".c-searchbar__suggestion-item-content-text").text();

                                    if (productText.length > 0)
                                        newText = productText;
                                    else
                                    {
                                        const anchorText = $selectedItem.first().find("a").text();
                                        if (anchorText.length > 0)
                                            newText = anchorText;
                                    }

                                    $(this).val(newText);
                                }
                            }
                        }
                    });

                    $(".c-searchbar__suggestion").show();
                }
            }
        }
    };

    const searchBarFocusInEventHandler = function (e: JQuery.TriggeredEvent): void
    {
        if ($(".c-searchbar__suggestion:visible").length <= 0)
        {
            $(".c-searchbar__suggestion").html("");
            if ($(".c-searchbar__suggestion-list").length > 0)
                $(".c-searchbar__suggestion").append($(".c-searchbar__suggestion-list").clone());
            oldSearchBarText = "";
        }

        $(".c-searchbar__suggestion").show();
    };

    $(".c-searchbar__form .c-searchbar__input")
        .on("click", searchBarClickEventHandler)
        .on("focusin", searchBarFocusInEventHandler);

    searchCookie(false);
}

//#endregion Search events

//#region Mobile menu

function initMobileMenu()
{
    if ($(".js-toggle-menu").length > 0)
    {
        const content: Array<PopupContent> = [];
        const subPages: Array<PopupContent> = [];
        const contentEl = document.createElement("div");

        const menuHolderEl = document.createElement("div");
        const myAccountEl = document.createElement("div");
        const customerServiceEl = document.createElement("div");
        let indexCount = 1;

        menuHolderEl.className = "c-mobilemenu__categories border-bottom-100";
        myAccountEl.className = "c-mobilemenu__account border-bottom-100";
        customerServiceEl.className = "c-mobilemenu__customerservice";

        const searchBar = `<div class="c-searchbar__holder">
                <form class="c-searchbar__form" method="post" data-action="/Services/Modules/Autocomplete.aspx" onsubmit="searchSubmit(this);">
                    <input type="search" class="c-searchbar__input" name="search-mobile" placeholder="Waar ben je naar op zoek?" data-autocomplete="off" />
                    <button type="submit" class="c-searchbar__button btn-icon btn-icon-after ic-search-aft p-none"></button>
                </form>                
            </div>`;

        const searchBarElement = document.createElement("div");
        searchBarElement.classList.add("c-searchbar", "c-searchbar--menu-mobile");
        searchBarElement.innerHTML = searchBar.trim();

        if ($(".c-headermenu").length > 0)
        {
            const menuUl = document.createElement("ul");
            menuUl.className = "c-mobilemenu__list nolist";
            $(".c-headermenu .c-headermenu__item").each(function ()
            {
                const menuItemLi = document.createElement("li");
                menuItemLi.className = "c-mobilemenu__item";

                let menuItemAnchor = null;

                if ($(this).find(".c-headermenu__category-column").length > 0)
                {
                    menuItemAnchor = document.createElement("div");
                    menuItemAnchor.className = "c-mobilemenu__link";
                    menuItemAnchor.style = $(this).find(".c-headermenu__link").attr("style");
                    menuItemAnchor.setAttribute("data-index", indexCount.toString());
                    menuItemAnchor.addEventListener("click", function ()
                    {
                        mobileMenuPopup.showBackButton(backButton);
                        openTab($(this).data("index"));
                    });
                }
                else
                {
                    menuItemAnchor = document.createElement("a");
                    menuItemAnchor.className = "c-mobilemenu__link";
                    menuItemAnchor.href = $(this).find(".c-headermenu__link").attr("href");
                    menuItemAnchor.style = $(this).find(".c-headermenu__link").attr("style");
                }

                const menuItemIconEl = document.createElement("img");
                menuItemIconEl.className = "c-mobilemenu__image";
                menuItemIconEl.src = $(this).data("mobilephotourl");
                menuItemIconEl.alt = $(this).find(".c-headermenu__link").text();
                menuItemAnchor.appendChild(menuItemIconEl);

                const menuItemSpan = document.createElement("span");
                menuItemSpan.className = "c-mobilemenu__span f-primary-s";
                menuItemSpan.innerText = $(this).find(".c-headermenu__link").text();
                menuItemAnchor.appendChild(menuItemSpan);

                menuItemLi.appendChild(menuItemAnchor);

                if ($(this).find(".c-headermenu__category-column").length > 0)
                {
                    const subPageContent = document.createElement("div");
                    const menuShowallAnchor = document.createElement("a");

                    menuShowallAnchor.className = "c-mobilemenu-showall__link f-primary-s";
                    menuShowallAnchor.text = getTranslations().txtViewall + " " + menuItemAnchor.innerText;
                    menuShowallAnchor.href = $(this).find(".c-headermenu__link").attr("href");
                    subPageContent.appendChild(menuShowallAnchor);

                    $(this).find(".c-headermenu__category-column").each(function ()
                    {
                        const $tabContent = $(this).clone();
                        $tabContent.removeClass("c-headermenu__category-column").addClass("c-mobilemenu__category-column border-bottom-100");
                        $tabContent.find(".c-headermenu__category-list").removeClass("c-headermenu__category-list").addClass("c-mobilemenu__category-list nolist");
                        subPageContent.appendChild($tabContent[0]);
                    });

                    const backButton = new PopupButton();
                    backButton.onClick = () =>
                    {
                        mobileMenuPopup.goToTab(0);
                        mobileMenuPopup.hideBackButton();
                    };

                    const menuItemArrowSpan = document.createElement("span");
                    menuItemArrowSpan.className = "c-mobilemenu__link-arrow";
                    menuItemArrowSpan.setAttribute("data-index", indexCount.toString());
                    menuItemArrowSpan.addEventListener("click", function ()
                    {
                        mobileMenuPopup.showBackButton(backButton);
                        openTab($(this).data("index"));
                    });
                    menuItemLi.appendChild(menuItemArrowSpan);

                    // Push subpages as popup tab
                    const subPage: PopupContent = { index: indexCount, content: subPageContent };
                    subPages.push(subPage);
                    indexCount++;

                    if ($(this).find(".c-headermenu__image-link").length > 0)
                    {
                        const $picture = $(this).find(".c-headermenu__image-link").clone();
                        $picture.removeClass("c-headermenu__image-link o-2xl");
                        $picture.addClass("c-mobilemenu__category-picture-link");
                        $picture.find(">:first-child").removeClass("c-headermenu__image br-2xl")
                        $picture.find(">:first-child").addClass("c-mobilemenu__category-picture");
                        subPageContent.appendChild($picture[0]);
                    }
                }

                menuUl.appendChild(menuItemLi);

            });

            menuHolderEl.appendChild(menuUl);
            contentEl.appendChild(searchBarElement);
            contentEl.appendChild(menuHolderEl);
        }

        if (menuAccountItems)
        {
            menuAccountItems.forEach((item: MenuItem) =>
            {
                if (item.isHeading)
                {
                    const headerEl = document.createElement("a");
                    headerEl.className = "c-mobilemenu__heading f-secondary-l";
                    headerEl.innerText = item.text;
                    headerEl.href = item.url;
                    headerEl.title = item.text;
                    myAccountEl.appendChild(headerEl);
                }

                if (shopConfig().userLoggedIn && item.loggedIn)
                {
                    const headerEl = document.createElement("a");
                    headerEl.className = "c-mobilemenu-footer__item f-primary-s";
                    headerEl.innerText = item.text;
                    headerEl.href = item.url;
                    headerEl.title = item.text;
                    myAccountEl.appendChild(headerEl);
                }
                else if (!shopConfig().userLoggedIn && !item.loggedIn && !item.isHeading)
                {
                    const headerEl = document.createElement("a");
                    headerEl.className = "c-mobilemenu-footer__item f-primary-s";
                    headerEl.innerText = item.text;
                    headerEl.href = item.url;
                    headerEl.title = item.text;

                    myAccountEl.appendChild(headerEl);
                }
            });

            contentEl.appendChild(myAccountEl);
        }

        if ($(".js-header-links").length > 0)
        {
            $(".js-header-links").find("a").each(function ()
            {
                const anchorElement = $(this)[0];
                const headerEl = document.createElement("a");
                headerEl.className = "c-mobilemenu-footer__item f-primary-s";
                headerEl.innerText = anchorElement.text;
                headerEl.href = anchorElement.href;
                headerEl.title = anchorElement.text;
                customerServiceEl.appendChild(headerEl);
            });
            contentEl.appendChild(customerServiceEl);
        }

        content.push({ index: 0, content: contentEl });

        subPages.forEach(value =>
        {
            content.push(value);
        });

        if ($(".js-header-country").length > 0)
        {
            const countryContentIndex = content.length + 1;
            const country = $(".js-header-country").data("country");
            const anchorElement = $(".js-header-country")[0] as HTMLAnchorElement;
            const headerEl = document.createElement("div");
            headerEl.className = `c-mobilemenu-footer__item f-primary-s c-mobilemenu-country__${country}`;
            headerEl.onclick = () =>
            {
                mobileMenuPopup.showBackButton(backButton);
                openTab(countryContentIndex);
            };

            const headerSpanEl = document.createElement("span");
            headerSpanEl.className = `c-mobilemenu-footer-item__text`;
            headerSpanEl.innerText = anchorElement.title;
            headerSpanEl.title = anchorElement.title;
            headerEl.appendChild(headerSpanEl);

            const menuItemArrowSpan = document.createElement("span");
            menuItemArrowSpan.className = "c-mobilemenu__link-arrow";
            headerEl.appendChild(menuItemArrowSpan);

            customerServiceEl.appendChild(headerEl);

            content.push({ index: countryContentIndex, content: new CountryPopup().getCountryContent() });
        }

        const mobileMenuPopupId = "mobile-menu-popup";

        const backButton = new PopupButton();
        backButton.onClick = () =>
        {
            mobileMenuPopup.goToTab(0);
            mobileMenuPopup.hideBackButton();
        };

        const mobileMenuPopup = new Popup({
            id: mobileMenuPopupId,
            content: content,
            closeButton: {
                label: "sluiten"
            },
            showLogo: true,
            logoCentered: true,
            mobilePosition: PopupPosition.fullScreen,
            desktopPosition: PopupPosition.Left,
            onHide: () =>
            {
                $("#modal-mobile-menu-popup").find(".c-searchbar__suggestion").html("");
            }
        });

        $(".js-toggle-menu").on("click", function ()
        {
            mobileMenuPopup.show();
        });

        function openTab(index: number)
        {
            mobileMenuPopup.goToTab(index);
        }
    }
}

//#endregion Mobile menu

//#region Overlay

const searchBar = document.querySelector<HTMLElement>(".c-searchbar");
const menuBar = document.querySelector<HTMLElement>(".c-headermenu__content");
const searchSuggestionBlock = document.querySelector<HTMLElement>(".c-searchbar__suggestion");

const overlayTransitionDelay = 150;
const overlayClass = "u-overlay__active";
const searchBarClass = "c-searchoverlay__active";
const menuBarClass = "c-menuoverlay__active";

function setOverlayEvents(
    element: HTMLElement | null,
    elementClass: string,
    allowHover: boolean = false,
    additionalHover: HTMLElement | null = null)
{
    if (element)
    {
        const toggleOverlay = (event: Event): void =>
        {
            let hasFocus = false;
            let hasHover = false;
            let hasAdditionalHover = false;
            let searchBarFocused = false;

            if (event.type === "focusin")
                hasFocus = true;
            else if (event.type === "focusout")
            {
                const nextFocusedElement = (event as FocusEvent).relatedTarget as HTMLElement | null;

                if (!nextFocusedElement || !element.contains(nextFocusedElement))
                    hasFocus = false;
            }

            if (allowHover)
            {
                if (event.type === "mouseenter" || event.type === "mouseover")
                    hasHover = true;
                if (event.type === "mouseleave" || event.type === "mouseout")
                    hasHover = false;
            }

            if (additionalHover)
            {
                if (event.currentTarget === additionalHover)
                {
                    if ($(".c-searchbar__input:focus").length > 0)
                        searchBarFocused = true;
                    else
                    {
                        if (event.type === "mouseenter")
                            hasAdditionalHover = true;
                        else if (event.type === "mouseleave")
                            hasAdditionalHover = false;
                    }
                }
            }

            let blockOverlay = false;

            // Exclude menu items without a submenu from showing overlay.
            if (element === menuBar)
            {
                // Get exact item triggering the event.
                const hoveredItem = element.querySelector('.c-headermenu__item:hover');
                const focusedItem = document.activeElement?.closest('.c-headermenu__item');
                const activeItem = hoveredItem || focusedItem;

                if (activeItem)
                {
                    // Block overlay if no submenu is present.
                    const hasSubmenu = activeItem.querySelector(".c-headermenu__category-wrapper") !== null;

                    if (!hasSubmenu)
                        blockOverlay = true;
                }
            }

            if (!blockOverlay &&
                (hasFocus || hasHover || hasAdditionalHover || searchBarFocused))
            {
                // Ensure no specific classes are present.
                document.body.classList.remove(searchBarClass, menuBarClass);

                document.body.classList.add(overlayClass, elementClass);
            }
            else
            {
                document.body.classList.remove(overlayClass);

                // Also remove all specific classes.
                document.body.classList.remove(searchBarClass);

                setTimeout(function ()
                {
                    if (!document.body.classList.contains(overlayClass))
                        document.body.classList.remove(menuBarClass);
                }, overlayTransitionDelay);
            }
        };

        const events = allowHover
            ? ["focusin", "focusout", "mouseover", "mouseout"]
            : ["focusin", "focusout"];
        events.forEach(eventType => element.addEventListener(eventType, toggleOverlay));

        if (additionalHover)
        {
            ["mouseenter", "mouseleave"].forEach(eventType =>
                additionalHover.addEventListener(eventType, toggleOverlay)
            );
        }
    }
}

setOverlayEvents(searchBar, searchBarClass, false, searchSuggestionBlock);
setOverlayEvents(menuBar, menuBarClass, true);

//#endregion Overlay

//#endregion Header

//#region Address validation

export const setValidateAddressEvents = (
    addressID: string | number,
    curCountryElement: string | JQuery,
    curStreetElement: JQuery,
    curResidenceElement: JQuery,
    curZipCodeElement: string | JQuery,
    curHouseNumberElement: string | JQuery,
    curStreetAddition: null | JQuery
): void =>
{
    const $country = $(curCountryElement as any);
    const $zipCode = $(curZipCodeElement as any);
    const $houseNumber = $(curHouseNumberElement as any);

    if ($country.length > 0 &&
        curStreetElement.length > 0 &&
        curResidenceElement.length > 0 &&
        $zipCode.length > 0 &&
        $houseNumber.length > 0
    )
    {
        let blurAddressElements: JQuery = curResidenceElement;
        let onchangeAddressElements: JQuery = $zipCode.add($houseNumber);

        if ($country.val() === "BE")
            onchangeAddressElements = onchangeAddressElements.add(curStreetElement);
        else
            blurAddressElements = blurAddressElements.add(curStreetElement);

        blurAddressElements.off("blur").on("blur", (event: JQuery.BlurEvent) =>
        {
            const countryVal = $country.val() as string;

            if ((
                (countryVal === "NL" && (curStreetElement.val() as string).length > 0) ||
                countryVal === "BE"
            ) &&
                (curResidenceElement.val() as string).length > 0
            )
                autocompleteAddress(addressID, curCountryElement, curStreetElement, curResidenceElement, curZipCodeElement, curHouseNumberElement, true, curStreetAddition);
        });

        $country.off("change.autocomplete").on("change.autocomplete", function (this: HTMLElement)
        {
            const $this = $(this);

            if ($this.val() === "NL" || $this.val() === "BE")
                autocompleteAddress(addressID, curCountryElement, curStreetElement, curResidenceElement, curZipCodeElement, curHouseNumberElement, true, curStreetAddition);
            else
            {
                $(`.addressnotfounderror${addressID}`).remove();
                $(`.useaddresssuggestion${addressID}`).remove();

                curStreetElement.removeClass("error");
                curResidenceElement.removeClass("error");
            }
        });

        onchangeAddressElements.off("change").on("change", (event: JQuery.ChangeEvent) =>
        {
            const countryVal = $country.val() as string;

            if (
                (
                    countryVal === "NL" ||
                    (countryVal === "BE" && (curStreetElement.val() as string).length > 0)
                ) &&
                ($zipCode.val() as string).length > 0 &&
                ($houseNumber.val() as string).length > 0
            )
                autocompleteAddress(addressID, curCountryElement, curStreetElement, curResidenceElement, curZipCodeElement, curHouseNumberElement, false, curStreetAddition);
        });
    }
}

function setAllValidateAddressEvents(): void
{
    const $curCountryElement = $(".validateaddress-country select");
    const $curStreetElement = $(".validateaddress-street");
    const $curResidenceElement = $(".validateaddress-residence");
    const $curZipCodeElement = $(".validateaddress-zipcode");
    const $curHouseNumberElement = $(".validateaddress-housenumber");

    setValidateAddressEvents(0, $curCountryElement, $curStreetElement, $curResidenceElement, $curZipCodeElement, $curHouseNumberElement, null);
}

(window as any).setValidateAddressEvents = setValidateAddressEvents;

const useAddressSuggestionButton = `<button class="btn useaddresssuggestion useaddresssuggestion{1}" type="button" onclick="useAddressSuggestion(this, {1}, '{2}', '{3}');">{0}</button>`;

function useAddressSuggestion(sender, addressID, streetSuggestion, residenceSuggestion)
{
    var senderGrandParent = $(sender).parent().parent();

    var streetElement = $("#street");
    var residenceElement = $("#residence");

    if (($(senderGrandParent).find("#street").length <= 0 && $(senderGrandParent).find("#street-delivery").length > 0) ||
        ($(senderGrandParent).find("#residence").length <= 0 && $(senderGrandParent).find("#residence-delivery").length > 0))
    {
        streetElement = $("#street-delivery");
        residenceElement = $("#residence-delivery");
    }

    if (streetElement.length <= 0)
    {
        if ($(".address-item").length > 0)
            streetElement = $(sender).closest(".address-item").find("input[id^=\"street\"]:visible");
        else
            streetElement = $("input[class^=\"delivery_street\"]:visible");
    }

    if (residenceElement.length <= 0)
    {
        if ($(".address-item").length > 0)
            residenceElement = $(sender).closest(".address-item").find("input[id^=\"residence\"]:visible");
        else
            residenceElement = $("input[class^=\"delivery_residence\"]:visible");
    }

    if (streetSuggestion.length > 0)
    {
        $(streetElement).val(streetSuggestion);
        $(streetElement).text(streetSuggestion);
    }

    if (residenceSuggestion.length > 0)
    {
        $(residenceElement).val(residenceSuggestion);
        $(residenceElement).text(residenceSuggestion);
    }

    $(".addressnotfounderror" + addressID).remove();
    $(".useaddresssuggestion" + addressID).remove();

    $(streetElement).removeClass("error");
    $(residenceElement).removeClass("error");
}

export function autocompleteAddress(
    addressID: string | number,
    curCountryElement: string | JQuery,
    curStreetElement: JQuery,
    curResidenceElement: JQuery,
    curZipCodeElement: string | JQuery,
    curHouseNumberElement: string | JQuery,
    validateAddress: boolean,
    curStreetAddition: null | JQuery
): void
{
    let addressFound: boolean = true;

    const $country = $(curCountryElement as any);
    const $zipCode = $(curZipCodeElement as any);
    const $houseNumber = $(curHouseNumberElement as any);

    const countryVal = $country.val() as string;
    const zipCodeVal = $zipCode.val() as string;
    const houseNumberVal = $houseNumber.val() as string;
    const streetVal = curStreetElement.val() as string;
    const residenceVal = curResidenceElement.val() as string;

    let addressKey: string = `${countryVal}_${zipCodeVal}_${houseNumberVal}`;

    if (countryVal === "BE")
        addressKey += `_${streetVal}`;

    addressKey = addressKey.replace(" ", "");

    let fromSession: boolean = false;

    const clearErrors = () =>
    {
        $(`.addressnotfounderror${addressID}, .useaddresssuggestion${addressID}`).remove();
        curStreetElement.add(curResidenceElement).removeClass("error");
    };

    const errorCallback = (result: any, responseState: string) =>
    {
        if (responseState === "error" && result)
        {
            $(".useaddresssuggestion").remove();

            if ($(`.addressnotfounderror${addressID}`).length > 0)
                $(`.addressnotfounderror${addressID}`).replaceWith($(`<div class="addressnotfounderror addressnotfounderror${addressID}">${getTranslations().addressNotFoundCheckAddressText}</div>`));
            else
                $(`<div class="addressnotfounderror addressnotfounderror${addressID}">${getTranslations().addressNotFoundCheckAddressText}</div>`).insertAfter(curResidenceElement.parent());
        }

        $(".js-street-residence").removeClass("hidden");
    }

    const callback = (result: any, responseState: string) =>
    {
        $(`.js-street-residence`).removeClass("hidden");

        $(curStreetElement).attr("required", "required").removeAttr("readonly");

        if ($($country).val() !== "FR")
            $(curStreetAddition).attr("required", "required").removeAttr("readonly");

        $(curResidenceElement).attr("required", "required").removeAttr("readonly");

        if (responseState === "success" && result)
        {
            if (typeof result.settlement === "undefined")
                result.settlement = result.city;

            if (!fromSession)
                $.stash.set(addressKey, `${result.street},${result.settlement}`);

            if (validateAddress)
            {
                if (getTranslations().addressNotFoundSuggestionText.length > 0 &&
                    typeof result.street !== "undefined" &&
                    typeof result.settlement !== "undefined" &&
                    result.street !== null &&
                    result.settlement !== null &&
                    (
                        result.street.toLowerCase() !== streetVal.toLowerCase() ||
                        result.settlement.toLowerCase() !== residenceVal.toLowerCase()
                    )
                )
                {
                    addressFound = false;

                    const notFoundMessage = getTranslations().addressNotFoundSuggestionText
                        .replace("{0}", result.street)
                        .replace("{1}", houseNumberVal)
                        .replace("{2}", result.settlement);

                    if ($(`.addressnotfounderror${addressID}`).length > 0)
                        $(`.addressnotfounderror${addressID}`).replaceWith($(`<div class="addressnotfounderror addressnotfounderror${addressID}">${notFoundMessage}</div>`));
                    else
                        $(`<div class="addressnotfounderror addressnotfounderror${addressID}">${notFoundMessage}</div>`).insertAfter(curResidenceElement.parent());

                    if ($(`.useaddresssuggestion${addressID}`).length <= 0 && getTranslations().addressUseSuggestionText.length > 0)
                    {
                        let suggestedStreet = result.street;
                        let suggestedSettlement = result.settlement;

                        if (suggestedStreet)
                            suggestedStreet = suggestedStreet.replaceAll("'", "\\'");

                        if (suggestedSettlement)
                            suggestedSettlement = suggestedSettlement.replaceAll("'", "\\'");

                        $(useAddressSuggestionButton
                            .replaceAll("{0}", getTranslations().addressUseSuggestionText)
                            .replaceAll("{1}", addressID.toString())
                            .replaceAll("{2}", suggestedStreet)
                            .replaceAll("{3}", suggestedSettlement)
                        ).insertAfter($(`.addressnotfounderror${addressID}`));
                    }

                    curResidenceElement.addClass("error");
                    curStreetElement.addClass("error");
                }
                else if ($(`.addressnotfounderror${addressID}`).length > 0)
                    clearErrors();
            }
            else
            {
                clearErrors();

                if (countryVal.toLowerCase() === "nl")
                {
                    if (typeof result.street !== "undefined" && result.street !== null)
                    {
                        $(`#hidden_street${addressID}`).val(result.street);
                        curStreetElement.val(result.street);
                    }
                }

                const addressResults = result;

                if (addressResults.length > 1)
                {
                    $(`#residence_select${addressID} option`).addClass("old");

                    let selectedOption: boolean = false;

                    $.each(addressResults, (i: number, addressResult: any) =>
                    {
                        const cityText = $(addressResult).find("city").text().toUpperCase();

                        if (cityText === $(`#hidden_residence${addressID}`).val())
                            selectedOption = true;

                        $("<option />")
                            .prop("value", cityText)
                            .prop("selected", cityText === $(`#hidden_residence${addressID}`).val())
                            .text(cityText)
                            .appendTo($(`#residence_select${addressID}`));
                    });

                    $(`#residence_select${addressID} option.old`).remove();

                    curResidenceElement.val("").prop("disabled", true).hide();
                    $(`#residence_select${addressID}`).removeProp("disabled").show();

                    if (!selectedOption)
                        $(`#hidden_residence${addressID}`).val($(`#residence_select${addressID} option:first`).val() as string);
                }
                else
                {
                    if (typeof result.settlement !== "undefined" && result.settlement !== null)
                    {
                        $(`#hidden_residence${addressID}`).val(result.settlement.toUpperCase());
                        curResidenceElement.val(result.settlement.toUpperCase());
                    }
                    $(`#residence_select${addressID}`).val("").prop("disabled", true).hide();
                    curResidenceElement.removeProp("disabled").show();
                }

                if (countryVal.toLowerCase() === "nl")
                {
                    curStreetElement.add(curResidenceElement).removeAttr("readonly").css({
                        "background-color": "White",
                        "border": "1px solid #949491"
                    });
                }
                else if (countryVal.toLowerCase() === "be")
                {
                    curResidenceElement.removeAttr("readonly").css({
                        "background-color": "White",
                        "border": "1px solid #ABADB3"
                    });
                }
            }
        }
        else
        {
            addressFound = false;

            $(`#residence_select${addressID}`).val("").prop("disabled", true).hide();
            curResidenceElement.removeProp("disabled").show();
            $(`#hidden_residence${addressID}`).val(residenceVal);

            curStreetElement.add(curResidenceElement)
                .removeAttr("readonly")
                .removeAttr("tabstop")
                .css({
                    "background-color": "White",
                    "border": "1px solid #949491"
                });
        }

        if (validateAddress)
        {
            if (getTranslations().addressNotFoundText.length > 0 && !addressFound)
            {
                if ($(`.addressnotfounderror${addressID}`).length <= 0)
                    $(`<div class="addressnotfounderror addressnotfounderror${addressID}">${getTranslations().addressNotFoundText}</div>`).insertAfter(curResidenceElement.parent());
            }
            else
                clearErrors();
        }
    }

    if ($.stash.exists(addressKey) && typeof $.stash.get(addressKey) !== "undefined")
    {
        fromSession = true;
        const str_array = $.stash.get(addressKey).split(",");

        if (str_array[0] !== null &&
            str_array[1] !== null &&
            str_array[0] !== "null" &&
            str_array[1] !== "null"
        )
            callback({ street: str_array[0], settlement: str_array[1] }, "success");
    }
    else
    {
        const pro6PPAddress = new Pro6PPAddressDto({
            zipCode: zipCodeVal,
            houseNumber: houseNumberVal,
            countryCode: countryVal,
            countryID: 0
        });

        if (countryVal === "BE" && streetVal && streetVal.length > 0)
            pro6PPAddress.street = streetVal;

        sendApiCall({
            endpoint: "/Address/AutoComplete",
            shopMode: origin,
            rawUrl: location.pathname,
            qsDictionary: [{}],
            formDictionary: [{}],
            callback: callback,
            customDto: pro6PPAddress,
            beforeSend: null,
            callType: null,
            errorCallback: errorCallback
        });
    }
}

(window as any).autocompleteAddress = autocompleteAddress;

(window as any).useAddressSuggestion = useAddressSuggestion;

//#endregion Address validation

//#region Desktop Menu

const desktopMenu = () =>
{
    const categories = document.getElementsByClassName("c-headermenu__category-wrapper") as HTMLCollectionOf<HTMLDivElement>;

    if (!categories) return;

    Array.from(categories).forEach((category: HTMLDivElement) =>
    {
        const subCategories = category.getElementsByClassName("c-headermenu__category-column") as HTMLCollectionOf<HTMLDivElement>;

        if (subCategories.length <= 4) return;

        const imageBlock = category.querySelector(".c-headermenu__image-block ") as HTMLDivElement;
        imageBlock.remove();
    })
}

desktopMenu();

//#endregion

let stashScroll;
let categoryScrollTop;

function handleStash()
{
    if ($("#backToURL").length > 0)
    {
        let changedCat = false;
        if ($.stash.exists('lastCategoryName') && $.stash.exists('lastCategoryUrl'))
        {
            var catName = $.stash.get('lastCategoryName');
            var catUrl = $.stash.get('lastCategoryUrl');
            if (catName.length > 0)
            {
                if (catName.toLowerCase() == 'home' && catUrl.indexOf('search') >= 0)
                    catName = getTranslations().txtUtilSearch;

                if (catUrl.indexOf(getTranslations().shoppingCartUrlLowerCaseTxt) >= 0)
                    catName = getTranslations().txtUtilShoppingCart;

                if ($(".js-pdp-brand").text() == catName)
                    $(".js-back-button").text(getTranslations().txtGoBackTo + ' ' + catName);
                else
                    $(".js-back-button").text(getTranslations().txtGoBackTo + ' ' + catName.toLowerCase());

                $(".js-back-button").prop('href', catUrl);

                $(".js-back-button").prop("title", getTranslations().txtGoBackTo + ' ' + catName.toLowerCase());
                $(".js-back-button").on('click', function ()
                {
                    $.stash.set('return-from-product', true);
                });
                changedCat = true;
            }
        }

        if (!changedCat && $("#productdetail-backurl").length > 0)
        {
            const categoryTitle = $("#productdetail-backurl").text().toLowerCase();
            const linkTitle = `${categoryTitle.charAt(0).toUpperCase()}${categoryTitle.slice(1)}`;

            $(".js-back-button").text(linkTitle);
            $(".js-back-button").prop("href", $("#productdetail-backurl").prop("href"));
            $(".js-back-button").prop("title", linkTitle);

            $(".js-back-button").on('click', function ()
            {
                $.stash.set('return-from-product', true);
            });
        }

        if ($.stash.exists('listname'))
        {
            var listName = $.stash.get('listname');

            if ($("#list").length > 0)
                $("#list").val(listName);

            $.stash.remove('listname');
        }
    }
    else if ($(".featureditems").length > 0)
    {
        if ($.stash.exists('return-from-product') && $.stash.exists('scroll-from-top'))
        {
            var scroll = parseInt($.stash.get('scroll-from-top'));

            $.stash.remove('return-from-product');
            $.stash.remove('scroll-from-top');
            categoryScrollTop = scroll;
            dynamicScroll(scroll);

            setTimeout(function ()
            {
                var topNow = $(window).scrollTop();

                if (topNow != scroll)
                    dynamicScroll(scroll);
            }, 250);

            if ($.stash.get('filter-is-open') == "1" && $(".filterbtn").css("display") == "block")
                $(".filterbtn").trigger('click');

            $.stash.remove('filter-is-open');
        }
        else if ($.stash.exists('lastCategoryUrl') && $.stash.exists('scroll-from-top'))
        {
            var categoryUrl = $.stash.get('lastCategoryUrl');

            if (categoryUrl == window.location.href)
            {
                var scroll = parseInt($.stash.get('scroll-from-top'));
                categoryScrollTop = scroll;
                $.stash.remove('scroll-from-top');

                dynamicScroll(scroll);

                setTimeout(function ()
                {
                    var topNow = $(window).scrollTop();

                    if (topNow != scroll)
                        dynamicScroll(scroll);
                }, 250);
            }
            else
                stashScroll = null;
        }

        if ($.stash.exists('pushHistory'))
        {
            var historyValue = JSON.parse($.stash.get('pushHistory'));

            for (var i = 0; i < historyValue.length; i++)
            {
                pushToHistory(historyValue[i], false, true);
            }
        }
    }
    else if ($("#continue-shopping").length > 0)
    {
        if ($.stash.exists('lastCategoryName') && $.stash.exists('lastCategoryUrl'))
        {
            var catName = $.stash.get('lastCategoryName');
            var catUrl = $.stash.get('lastCategoryUrl');

            if (catName.toLowerCase() == 'home' && catUrl.indexOf('search') >= 0)
                catName = getTranslations().txtUtilSearch;

            if (catUrl != getTranslations().shoppingCartUrlLowerCaseTxt)
                $("#continue-shopping").prop('href', catUrl);

            $("#continue-shopping").on('click', function ()
            {
                $.stash.set('return-from-product', true);
            });
        }

        if ($.stash.exists('listname'))
        {
            var listName = $.stash.get('listname');

            if ($("#list").length > 0)
                $("#list").val(listName);

            $.stash.remove('listname');
        }
    }
    else if ($("#priceForm").length > 0)
    {
        $.stash.set('lastCategoryUrl', getTranslations().shoppingCartUrlLowerCaseTxt);
    }
    else if (location.pathname == "/" || location.pathname == getTranslations().homeUrlLowerCaseTxt)
    {
        $.stash.remove('lastCategoryUrl');
    }
}

const dynamicScroll = (scroll) =>
{
    let docHeight = $(document).height() - $("#footer").height();

    if ($(".banner-holder").length > 0)
        docHeight = docHeight - $(".banner-holder").height();

    var filterHeight = $(".fileterarea").height();
    var productHeight = $(".featureditems").height();

    if (filterHeight == 0 || productHeight < filterHeight)
    {
        $(window).scrollTop($(".featureditems .featureditem:last").offset().top - 120);
        stashScroll = scroll;
    }
    else if (docHeight < scroll)
    {
        $(window).scrollTop($(document).height() - $("#footer").height());
        stashScroll = scroll;
    }
    else
    {
        $(window).scrollTop(scroll);
        stashScroll = null;
    }
}

let pushHistory = [];

// Pushes a url to the history array and push state, only when not ignored
function pushToHistory(url, ignoreHistory, ignoreState)
{
    var lastHistoryEntry = pushHistory[pushHistory.length - 1];

    // Skip adding url to history if it already is the last entry, prevents window reload to add the same url.
    if (url === lastHistoryEntry)
        return;

    if (url.indexOf('#keuzehulp') >= 0)
        url = url.replace("#keuzehulp", "");

    if (!ignoreHistory)
        pushHistory.push(url);

    if (!ignoreState)
        history.pushState({}, null, url);

    $.stash.set("pushHistory", JSON.stringify(pushHistory));
}

function setupOldBrowserWarning()
{
    var currentCookie = Cookies.get('HideOldBrowserModal');
    if (typeof (currentCookie) === 'undefined' || currentCookie === null || currentCookie.length == 0)
    {
        var userAgent = navigator.userAgent;

        // check user agent        
        if (userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident") > -1)
        {
            var outdatedBrowserWarningTitle = getTranslations().txtOutdatedBrowserWarningTitle;
            var outdatedBrowserWarningText = getTranslations().OutdatedBrowserWarningText;

            if (typeof outdatedBrowserWarningTitle !== "undefined" && outdatedBrowserWarningTitle != null && outdatedBrowserWarningTitle.length > 0 &&
                typeof outdatedBrowserWarningText !== "undefined" && outdatedBrowserWarningText != null && outdatedBrowserWarningText.length > 0)
            {

                const buttonHide = new PopupButton();
                buttonHide.label = getTranslations().OutdatedBrowserDontShow;
                buttonHide.className = "btn";
                buttonHide.onClick = () =>
                {
                    hideOldBrowserWarning()
                };

                const oldBrowserPopup = new Popup({
                    id: "browser-check",
                    title: outdatedBrowserWarningTitle,
                    desktopPosition: PopupPosition.CenterSmall,
                    mobilePosition: PopupPosition.Drawer,
                    closeButton: true,
                    content: outdatedBrowserWarningText,
                    buttons: [buttonHide]
                }).show();
            }
        }
    }
}

function hideOldBrowserWarning()
{
    Cookies.set('HideOldBrowserModal', '1');
}

function setupBrowserWarning()
{
    var isFacebookInAppBrowser = false;
    var isIos = false;
    var isAndroid = false;
    var userAgent = navigator.userAgent;

    // check user agent
    if (userAgent.indexOf("FB_IAB") > -1 || userAgent.indexOf("FBAN") > -1)
    {
        isFacebookInAppBrowser = true;

        if (userAgent.indexOf("FBIOS") > -1)
            isIos = true;
        else if (userAgent.indexOf("FB4A") > -1)
            isAndroid = true;
    }

    if (isFacebookInAppBrowser)
    {
        var dialogText =
            '<button class="uk-modal-close uk-icon uk-close" type="button" uk-close=""></button>' +
            '<p>' + getTranslations().txtInAppFacebookBrowserWarning + '</p>';

        if (isAndroid)
        {
            dialogText += '<button class="redirectBrowserButton" onclick="redirectToDeviceDefaultBrowser();">' + getTranslations().TextInAppFacebookBrowserWarningChromeButton + '</button><br/>';
            dialogText += '<a class="uk-modal-close redirectBrowserContinueButton">' + getTranslations().TextInAppFacebookBrowserWarningContinueButton + '</a>';
        }
        else
            dialogText += '<button class="uk-modal-close redirectBrowserButton" >' + getTranslations().TextInAppFacebookBrowserWarningContinueButton + '</button>';

        var modal = UIkit.modal.dialog(dialogText);
        modal.$el.firstElementChild.classList.add('uk-margin-auto-vertical');
        modal.$el.firstElementChild.classList.add('modal-warning-dialog');

        sendDataLayer({ 'event': getTranslations().txtInAppFacebookBrowserWarning });
    }

    if (!isAndroid)
        $('#linkToDefaultBrowser').hide();
}

const redirectToDeviceDefaultBrowser = () =>
{
    var currentLocation = window.location.href;
    if (currentLocation.indexOf('?') < 0)
        currentLocation += '?utm_term=fb_abtest';
    else
        currentLocation += '&utm_term=fb_abtest';

    window.open('intent:' + encodeURI(currentLocation) + '/#Intent;scheme=https;package=com.android.chrome;action=android.intent.action.VIEW;end;');
}

